import { Backdrop, CircularProgress } from '@mui/material';
import TradesTable from 'components/ppa-trade/TradesTable';
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useApiService } from '../../services/ApiService/ApiService';

function TradeListPage(props: any) {
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [loading, setLoading] = useState(true);
    const [trades, setTrades] = useState([]) as any;
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    function checking_null_undefined(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }

    async function fetchTrades() {
        try {
            const response = await fetchWithAuth('/ppa/advanced/trade/list', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch trades');
            }

            const res_json = await response.json();
            res_json.trades = checking_null_undefined(res_json.trades);
            setTrades(res_json.trades.map((e: any) => ({ ...e, id: e.uuid })));
        } catch (error) {
            console.error('Error fetching trades:', error);
            setErrorMessage('Failed to fetch trades');
        } finally {
            setLoading(false);
        }
    }

    async function adoptTrade(tradeUuid: string) {
        setLoading(true);
        try {
            const response = await fetchWithAuth('/ppa/advanced/trade/adopt', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid,
                    powerPurchaseAgreementTradeUuid: tradeUuid
                })
            });

            const res_json = await response.json();

            if (!response.ok) {
                switch (res_json.code) {
                    case "CHARGING_PARTNER_NOT_FOUND":
                        setErrorMessage("No existing Power Purchase Agreement in place for the Charge Point Operator.");
                        break;
                    default:
                        setErrorMessage("An error (" + res_json.code + ") occurred whilst attempting to process the Trade.");
                        break;
                }
                return;
            }

            toast.success('Trade adoption successful', {
                position: 'bottom-center',
                duration: 5000,
            });
            fetchTrades();
        } catch (error) {
            console.error('Error adopting trade:', error);
            setErrorMessage('Failed to adopt trade');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage, {
                position: 'bottom-center',
                duration: 5000,
            });
        }
        setErrorMessage(null);
    }, [errorMessage]);


    useEffect(() => {
        fetchTrades();
    }, []);

    return (
        <div>
            <Backdrop open={loading} style={{ zIndex: 1300 }} >
                <CircularProgress color="inherit" />
            </Backdrop>

            {!loading && (

                <div className="container-fluid g-0" style={{ marginTop: "24px" }}>
                    <div className="row gy-2">
                        <div className="drag-drop-container">
                            <TradesTable trades={trades} adoptTrade={adoptTrade} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}


export default TradeListPage;
